/**
 * Cliente HTTP de Descuentos: wrappers tipados sobre `req()` de campana-nueva. Nunca se manda el comercio (sale del
 * token). Es del equipo: con el token de una persona de un cliente, el backend dice 403.
 */

import { req } from "../campana-nueva/api";
import type { Resp } from "../wa-oficial/api";
import type * as T from "./types";

const B = "/activa/descuentos";

export const descuentosApi = {
  ver: (): Promise<Resp<T.Descuentos>> => req("GET", B),
  guardar: (reglas: T.ReglasParaGuardar): Promise<Resp<T.Descuentos>> => req("PUT", B, reglas),
};
